export const API_ACTION_TIME_TRACKER_CREATE =
  'core-2/system/action-time-tracker';

export const API_ACTION_TIME_TRACKER_DELETE =
  'core-2/system/action-time-tracker';
